<script>
    import { fade } from 'svelte/transition';
    import EmotionPage from './EmotionPage.svelte';
    import ResultPage from './ResultPage.svelte';
	import RobotCheckPage from './RobotCheckPage.svelte';
    import { emotions } from './data.js';

    let currentStep = -1;
    let totalPoints = 0; // Keep track of the total points
    let percentage;

    let selectedEmotions = [];

    function proceedToQuiz() {
        selectedEmotions = [...emotions] // Spread to prevent mutation of the original array
            .sort(() => 0.5 - Math.random()) // Shuffle the array
            .slice(0, 4); // Get the first 4 items
        currentStep = 0;
    }

    function computePercentage() {
        if (currentStep === selectedEmotions.length) {
            percentage = (totalPoints / selectedEmotions.length) * 100;
        }
    }

    function restartQuiz() {
        // Reset the necessary variables to their initial state
        currentStep = -1;
        totalPoints = 0;
    }
</script>
<main>
    {#if currentStep === -1}
        <RobotCheckPage onConfirm={proceedToQuiz} />
    {:else if currentStep < selectedEmotions.length}
    <div in:fade={{ duration: 300 }} out:fade={{ duration: 300 }}>
        <EmotionPage emotionData={selectedEmotions[currentStep]} onNext={() => {
            totalPoints += selectedEmotions[currentStep].points;
            console.log(selectedEmotions[currentStep].points)
            currentStep++; 
            computePercentage();
        }} />
    </div>
    {:else if !isNaN(percentage)}
        <div in:fade={{ duration: 300 }} out:fade={{ duration: 300 }}>
            <ResultPage {percentage} onRestart={restartQuiz} />
        </div>
    {/if}
</main>
<style>
    main {
        width: 100%; /* Covers full width */
        height: 100%; /* Covers full height */
    }
</style>
